export default class WseTopperViewModel {
    public wseNumber: string = '';
    public plantItemNumber: string = '';
    public revisionNumber: string = '';
}